import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageTheSes = (props: Props) => {
    const { t } = useTranslation()
    return (
        <ManageBooks
            menu_name={t("จัดการวิทยานิพนธ์")}
            category={ELibraryCategory.THESIS}
            path_create={routeName.e_library.manage_the_ses_create}
            button_add_name={t("เพิ่มวิทยานิพนธ์")}
        />
    )
}

export default ManageTheSes